import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-video-preview-data.interface';
import { VideoFormat } from '../../../../../../../utils/youtube-format-helper';
import { YoutubeShortsAdDesktopShellComponent } from './youtube-shorts-ad-desktop-shell.component';

/**
 * Shorts ad for the 9:16 creative: the native Shorts format, so it fills the
 * player with no bands.
 */
@Component({
    selector: 'app-gen-youtube-shorts-ad-desktop-fullscreen',
    imports: [YoutubeShortsAdDesktopShellComponent],
    template: '<app-gen-youtube-shorts-ad-desktop-shell [data]="data" [format]="format" />',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class YoutubeShortsAdDesktopFullscreenPreviewComponent {
  @Input() data!: GenVideoPreviewData;

  readonly format: VideoFormat = '9:16';
}
